'use client';

import {
    Box,
    BoxContent,
    IconName,
    List,
    ListItem,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { FaiType, FaiTypeNugget } from '@app-types/plan';

import { getSpeedInfos } from '@helpers/speed-infos';

import '@promo-simulator/assets/styles/styles.css';

interface NuggetsListProps {
    plan?: FaiType;
    nuggets?: FaiTypeNugget[];
    displaySpeed?: boolean;
}

//TODO: improve this component to have only one source of data
export function NuggetsList({ plan, nuggets, displaySpeed = true }: Readonly<NuggetsListProps>) {
    const { upRates, downRates, speedWording } = plan ? getSpeedInfos(plan) : {};

    const getNuggets = (plan?: FaiType, nuggets?: FaiTypeNugget[]): FaiTypeNugget[] => {
        const returnedNuggets = plan?.nuggets ?? nuggets ?? [];

        if (!displaySpeed) {
            return returnedNuggets.filter((nug) => !nug.showSpeed);
        }

        return returnedNuggets;
    };

    const nug = getNuggets(plan, nuggets).sort((a, b) => {
        const positionA = a.position ?? Number.MAX_SAFE_INTEGER;
        const positionB = b.position ?? Number.MAX_SAFE_INTEGER;
        return positionA - positionB;
    });

    if (!nug.length) {
        return null;
    }

    return (
        <Box shadowless>
            <BoxContent backgroundColor={TrilogyColor.NEUTRAL_FADE}>
                <List>
                    {nug.map((nugget) => (
                        <ListItem key={nugget.label} iconName={nugget.icon as IconName}>
                            <Text level={TextLevels.TWO} marginless typo={TypographyAlign.TEXT_LEFT}>
                                {nugget.label}
                                {speedWording && nugget.showSpeed && ' ' + speedWording}
                                {plan && nugget.showSpeed && (
                                    <span
                                        aria-label={`${downRates} en débit descendant et ${upRates} en débit montant`}
                                    >
                                        {' '}
                                        ↓&nbsp;{downRates?.replace(' ', '\u00A0')}&nbsp;&nbsp;↑&nbsp;
                                        {upRates?.replace(' ', '\u00A0')}
                                    </span>
                                )}
                            </Text>
                        </ListItem>
                    ))}
                </List>
            </BoxContent>
        </Box>
    );
}
